import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { useNavigate, useParams } from 'react-router-dom';
import { postAuthSocialVerify } from 'utils/api';
import { menu } from 'utils/constants';

const OAuthVerify = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [message, setMessage] = useState('이메일 인증 처리 중입니다...');
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;

    const run = async () => {
      if (!token) {
        setMessage('유효하지 않은 인증 링크입니다.');
        return;
      }
      try {
        const res = await postAuthSocialVerify(token);
        if (res.statusCode !== 200 || !res.results?.token) {
          setMessage(res.message || '인증에 실패했습니다.');
          return;
        }
        localStorage.setItem('token', res.results.token);
        localStorage.setItem('name', res.results.name);
        localStorage.setItem('plan', res.results.plan || 'free');
        localStorage.setItem('email', res.results.email || '');
        navigate(menu.analysis.estateObjectList.link, { replace: true });
      } catch (e) {
        const msg = e?.response?.data?.message || '인증에 실패했습니다.';
        setMessage(msg);
      }
    };

    run();
  }, [token, navigate]);

  return (
    <Container>
      <Message>{message}</Message>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Message = styled.div`
  font-size: 14px;
  color: #495057;
`;

export default OAuthVerify;
